<template>
  <FormulateInput
    v-if="mask"
    :name="name"
    :type="type"
    :label="label"
    :validation="validation"
    :placeholder="placeholder"
    @blur-context="inputCallback"
    @validation="$emit('validation', $event)"
    v-model="value"
    :readonly="readonly"    
    v-mask="mask"
    v-bind="$attrs"
  />

  <FormulateInput
    v-else
    :name="name"
    :type="type"
    :label="label"
    :validation="validation"
    :placeholder="placeholder"
    @blur-context="inputCallback"
    @validation="$emit('validation', $event)"
    v-model="value"
    :readonly="readonly"    
    v-bind="$attrs"
  />
</template>
<script>
export default {
  name: "TextInputComponent",
  props: {
    name: {
      type: String,
      required: true,
    },
    mask: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  methods: {
    inputCallback(value){
      this.$emit('update', value)
    }
  }
};
</script>